
import React, { useState } from 'react';

const DedicatedDeveloper = () => {
  const [tab, setTab] = useState('web');
  const [faqOpen, setFaqOpen] = useState(1);
  const [processOpen, setProcessOpen] = useState(1);

  // Tab content for Hire For section
  const hireTabs = [
    {
      key: 'web',
      label: 'Web Development',
      icon: 'fa-code',
      content: (
        <div className="row g-4">
          <div className="col-12">
            <h3 className="details_item_info_title">What you get (Web)</h3>
            <ul className="icon_list unordered_list_block">
              <li><i className="fa-solid fa-layer-group text-primary me-2"></i> SPA/MPA builds with React, Next.js, Vue, Laravel, Node</li>
              <li><i className="fa-solid fa-gauge-high text-primary me-2"></i> Optimized performance, SEO, accessibility (WCAG)</li>
              <li><i className="fa-solid fa-shield-halved text-primary me-2"></i> Security hardening (OWASP), auth (OAuth/JWT)</li>
              <li><i className="fa-solid fa-diagram-project text-primary me-2"></i> CI/CD pipelines, staging & zero-downtime deployments</li>
            </ul>
            <a className="btn btn-primary mt-2" href="/web-development">
              <span className="btn_label" data-text="Explore Web Development">Explore Web Development</span>
              <span className="btn_icon"><i className="fa-solid fa-arrow-up-right"></i></span>
            </a>
          </div>
        </div>
      )
    },
    {
      key: 'mobile',
      label: 'Mobile App Development',
      icon: 'fa-mobile-screen-button',
      content: (
        <div className="row g-4">
          <div className="col-12">
            <h3 className="details_item_info_title">What you get (Mobile)</h3>
            <ul className="icon_list unordered_list_block">
              <li><i className="fa-solid fa-code-branch text-primary me-2"></i> Native iOS (Swift) & Android (Kotlin) or cross-platform (Flutter, React Native)</li>
              <li><i className="fa-solid fa-screwdriver-wrench text-primary me-2"></i> Secure APIs, push notifications, in-app purchases</li>
              <li><i className="fa-solid fa-certificate text-primary me-2"></i> App Store & Play Store compliance, builds & submissions</li>
              <li><i className="fa-solid fa-rotate text-primary me-2"></i> Continuous releases with monitoring (Sentry/Firebase)</li>
            </ul>
            <a className="btn btn-primary mt-2" href="/app-development">
              <span className="btn_label" data-text="Explore Mobile Development">Explore Mobile Development</span>
              <span className="btn_icon"><i className="fa-solid fa-arrow-up-right"></i></span>
            </a>
          </div>
        </div>
      )
    }
  ];

  // FAQ content
  const faqs = [
    {
      q: 'Is there a minimum contract or hourly block?',
      a: 'No long-term lock-in. Billing is month-to-month with a 40-hour minimum. Unused hours roll forward for 30 days, so you never lose paid time.'
    },
    {
      q: 'Can I scale the team up or down fast?',
      a: 'Yes. Add or pause assistants with 24-hour notice—perfect for seasonal peaks or project sprints. Your account manager handles onboarding and off-boarding paperwork.'
    },
    {
      q: 'What if I’m unhappy with task quality?',
      a: 'You get a dedicated QA lead who scores work daily. If accuracy ever drops below 98 %, we retrain or replace the VA at no extra cost within one business day.'
    },
    {
      q: 'Do you work in my time zone?',
      a: 'We staff assistants in US and APAC zones and can provide blended coverage for 24/7 support. Just tell us your preferred hours during onboarding.'
    },
    {
      q: 'How is communication handled?',
      a: 'Your VA is available in Slack, Teams or email—your choice. Weekly 15-minute stand-ups and a live dashboard keep you updated on task status and KPIs.'
    }
  ];

  // Service process steps
  const processSteps = [
    {
      title: '01. Discovery & Requirement Analysis',
      body: 'Understand your project scope, required tech stack, deadlines, and team size.'
    },
    {
      title: '02. Developer Shortlisting & Interviews',
      body: 'Match your needs with vetted developers. You interview and select the right fit.'
    },
    {
      title: '03. Onboarding & Setup',
      body: 'We integrate the developer(s) with your tools, workflows, and team communication.'
    },
    {
      title: '04. Active Development & Reporting',
      body: 'Developers work full-time, attend daily standups, push to your repos, and share progress reports.'
    },
    {
      title: '05. Continuous Support & Scale',
      body: 'Add/remove team members, extend scope, or shift tech requirements as your project evolves.'
    }
  ];

  return (
    <div className="page_wrapper">
      <main className="page_content">
        {/* Banner Section */}
        <section className="page_banner_section text-center" style={{ backgroundImage: "url('assets/images/shapes/bg_pattern_3.svg')" ,marginTop: '90px' }}>
          <div className="container">
            <div className="heading_focus_text text-white">
              Service <span className="badge bg-secondary">Details </span>
            </div>
            <h1 className="page_title mb-0 text-white">Dedicated Developer </h1>
          </div>
        </section>

        {/* Service Details Section */}
        <section className="service_details_section section_space bg-light">
          <div className="container">
            <div className="details_item_image position-relative">
              <img src="assets/images/service-details/Dedicated Developers.jpg" alt="Dedicated Developer Service" />
            </div>

            <h2 className="details_item_title">Dedicated Developer Services</h2>
            <p>
              Build a high-performance team without hiring headaches. Our Dedicated Developer service connects you with skilled engineers who work exclusively on your project—just like an in-house team, but without the overhead.
            </p>
            <p>
              Whether you're building a SaaS platform, launching an eCommerce solution, or scaling a startup MVP—our developers bring agile expertise, cross-functional collaboration, and product-first thinking to your team.
            </p>

            <div className="container my-5">
              <div className="heading_block text-center">
                <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: "url('assets/images/shapes/shape_title_under_line.svg')", color: '#0f6873' }}>
                  Hire For
                </div>
                <h2 className="heading_text mb-0">Dedicated <mark>Web</mark> & <mark>Mobile</mark> Developers</h2>
              </div>

              {/* Tabs */}
              <ul className="nav nav-pills justify-content-center mb-4" role="tablist">
                {hireTabs.map((tabItem) => (
                  <li className="nav-item" role="presentation" key={tabItem.key}>
                    <button
                      className={`nav-link${tab === tabItem.key ? ' active' : ''}`}
                      id={`tab-${tabItem.key}`}
                      type="button"
                      role="tab"
                      aria-selected={tab === tabItem.key}
                      onClick={() => setTab(tabItem.key)}
                    >
                      <i className={`fa-solid ${tabItem.icon} me-2`}></i> {tabItem.label}
                    </button>
                  </li>
                ))}
              </ul>

              <div className="tab-content">
                {hireTabs.map((tabItem) => (
                  <div
                    key={tabItem.key}
                    className={`tab-pane fade${tab === tabItem.key ? ' show active' : ''}`}
                    id={`pane-${tabItem.key}`}
                    role="tabpanel"
                  >
                    {tabItem.content}
                  </div>
                ))}
              </div>
            </div>

            <h3 className="details_item_info_title">Service Process</h3>
            <div className="row mb-5 align-items-center justify-content-lg-between">
              <div className="col-lg-6">
                <div className="accordion" id="service_process_faq">
                  {processSteps.map((step, idx) => (
                    <div className="accordion-item" key={idx}>
                      <div
                        className={`accordion-button${processOpen === idx + 1 ? '' : ' collapsed'}`}
                        role="button"
                        onClick={() => setProcessOpen(processOpen === idx + 1 ? null : idx + 1)}
                        aria-expanded={processOpen === idx + 1}
                        aria-controls={`collapse_${idx}`}
                      >
                        {step.title}
                      </div>
                      <div
                        id={`collapse_${idx}`}
                        className={`accordion-collapse collapse${processOpen === idx + 1 ? ' show' : ''}`}
                        data-bs-parent="#service_process_faq"
                      >
                        <div className="accordion-body">
                          <p className="m-0">{step.body}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-lg-5">
                <ul className="content_layer_group unordered_list_block text-center">
                  {processSteps.map((step, idx) => (
                    <li
                      className={`accordion-button${processOpen === idx + 1 ? '' : ' collapsed'}`}
                      role="button"
                      key={idx}
                      onClick={() => setProcessOpen(processOpen === idx + 1 ? null : idx + 1)}
                      aria-expanded={processOpen === idx + 1}
                      aria-controls={`collapse_${idx}`}
                    >
                      <span>{step.title.split('. ')[1]}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <h3 className="details_item_info_title">Service Inclusions</h3>
            <p className="mb-4">
              Every engagement includes infrastructure, communication setup, process alignment, and tools tailored to your development workflow.
            </p>
            <div className="row mb-4">
              <div className="col-lg-6">
                <ul className="icon_list unordered_list_block">
                  <li>
                    <i className="fa-solid fa-user-gear text-primary me-2"></i>
                    Dedicated developer(s) with agreed tech stack
                  </li>
                  <li>
                    <i className="fa-solid fa-clock text-primary me-2"></i>
                    Full-time, timezone-matched availability
                  </li>
                  <li>
                    <i className="fa-solid fa-comments text-primary me-2"></i>
                    Daily standups and weekly reports
                  </li>
                </ul>
              </div>
              <div className="col-lg-6">
                <ul className="icon_list unordered_list_block">
                  <li>
                    <i className="fa-solid fa-code-branch text-primary me-2"></i>
                    Git access & task management integration
                  </li>
                  <li>
                    <i className="fa-solid fa-shield-halved text-primary me-2"></i>
                    NDAs, code security, and IP protection
                  </li>
                  <li>
                    <i className="fa-solid fa-rotate text-primary me-2"></i>
                    Flexible scaling & developer replacement option
                  </li>
                </ul>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="details_item_image m-0">
                  <img src="assets/images/services-images/Dedicated-1.jpg" alt="Developer Writing Code" />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="details_item_image m-0">
                  <img src="assets/images/services-images/Dedicated-2.jpg" alt="Team Collaboration" />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="details_item_image m-0">
                  <img src="assets/images/services-images/Dedicated-3.jpg" alt="Progress Reporting" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="faq_section section_decoration">
          <div className="container">
            <div className="heading_block text-center">
              <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: "url('assets/images/shapes/shape_title_under_line.svg')" }}>
                F.A.Q.
              </div>
              <h2 className="heading_text mb-0">
                Need a <mark>Support?</mark>
              </h2>
            </div>

            <div className="faq_accordion accordion" id="faq_accordion">
              {faqs.map((faq, idx) => (
                <div className="accordion-item" key={idx}>
                  <div
                    className={`accordion-button${faqOpen === idx + 1 ? '' : ' collapsed'}`}
                    role="button"
                    onClick={() => setFaqOpen(faqOpen === idx + 1 ? null : idx + 1)}
                    aria-expanded={faqOpen === idx + 1}
                    aria-controls={`collapse_faq_${idx}`}
                  >
                    Q. {faq.q}
                  </div>
                  <div
                    id={`collapse_faq_${idx}`}
                    className={`accordion-collapse collapse${faqOpen === idx + 1 ? ' show' : ''}`}
                    data-bs-parent="#faq_accordion"
                  >
                    <div className="accordion-body">
                      <div className="text_a">A.</div>
                      <p>{faq.a}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="decoration_item shape_image_1">
            <img src="assets/images/shapes/shape_space_4.svg" alt=" Shape" />
          </div>
        </section>

        {/* Call To Action Section */}
        <section className="calltoaction_section parallaxie" style={{ backgroundImage: "url('assets/images/backgrounds/staffing.jpg')" }}>
          <div className="container text-center">
            <div className="heading_block text-white">
              <h2 className="heading_text">
                Ready to Work, Let's Chat
              </h2>
              <p className="heading_description mb-0">
                Our team of experts is ready to collaborate with you every step of the way, from initial consultation to implementation.
              </p>
            </div>
            <a className="btn btn-primary" href="/contact">
              <span className="btn_label" data-text="Contact Us Today!">Contact Us Today!</span>
              <span className="btn_icon">
                <i className="fa-solid fa-arrow-up-right"></i>
              </span>
            </a>
          </div>
        </section>
      </main>
    </div>
  );
};

export default DedicatedDeveloper;
